import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import placeholderImg from "../assets/images/new/newslattr.png";

import { X } from "lucide-react";
import { t } from "i18next";
function SuccessModal({ show, onHide, onConfirm, Action }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="border-0 shadow-lg rounded-4"
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "#fdfdfd",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* Cancel Icon */}
        <button
          onClick={onHide}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            color: "#555",
            cursor: "pointer",
            fontSize: "20px",
          }}
        >
          <X size={24} />
        </button>

        {/* Modal Header */}
        <Modal.Title
          className="text-center mt-4 mb-2"
          style={{
            fontSize: "26px",
            fontWeight: "700",
            color: "#A52444",
            textTransform: "capitalize",
          }}
        >
          {Action === "Contact" ? t("Thank You!") : t("Subscription Successful!")}
        </Modal.Title>

        {/* Modal Body */}
        <Modal.Body
          style={{
            backgroundColor: "#f9f7f7",
            color: "#222",
            textAlign: "center",
            padding: "25px",
          }}
        >
          <img
            src={placeholderImg}
            alt="Success"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "contain",
              marginBottom: "15px",
            }}
          />

          <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#333" }}>
            {Action === "Contact" ? (
              <>{t("Thank you for contacting us. Our team will reach out to you shortly.")}</>
            ) : (
              <>
                {t("Thank you for subscribing to our newsletter.")}
                <br /> {t("We will keep you informed with the latest updates.")}
              </>
            )}
          </p>
        </Modal.Body>

        {/* Optional footer border for design */}
        <div
          style={{
            height: "6px",
            background: "linear-gradient(90deg, #A52444, #FF9900)",
            borderRadius: "0 0 12px 12px",
          }}
        />
      </div>
    </Modal>
  );
}

export default SuccessModal;
